(function () {
    "use strict";

    HotJarIntegrationService.$inject = [];

    function HotJarIntegrationService() {
        var self = this;
        var initialized = false;

        self.addTracking = function () {
            // numberOfInitCalls == 1, this means this is an entry page
            if (!initialized) {
                (function (h, o, t, j, a, r) {
                    h.hj = h.hj || function () {
                        (h.hj.q = h.hj.q || []).push(arguments)
                    };
                    h._hjSettings = {hjid: 1444839, hjsv: 6};
                    a = o.getElementsByTagName('head')[0];
                    r = o.createElement('script');
                    r.async = 1;
                    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

                initialized = true;
            }
        }
    }

    angular
        .module("harriApp")
        .service("hotJarTracking", HotJarIntegrationService);
})();